// antd-theme.js
// Ant Design theme configuration based on MUI theme.js colors
import theme from "./theme";

/**
 * Maps MUI theme colors to Ant Design Design Tokens
 * This allows Ant Design components to use the project's unified color system
 */
export const antdTheme = {
  token: {
    // Primary colors
    colorPrimary: theme.palette.primary.main, // #475B63
    colorSuccess: theme.palette.background.c1, // #9fe3a8
    colorWarning: theme.palette.background.l2, // #e1c9a8
    colorError: theme.palette.background.l3, // #d19191
    colorInfo: theme.palette.background.l6, // #8fbdcf

    // Background colors
    colorBgContainer: theme.palette.background.card, // #FFFFFF
    colorBgElevated: theme.palette.background.l0, // #FFFFFF
    colorBgLayout: theme.palette.background.default, // #EAEEF0
    colorBgSpotlight: theme.palette.background.l1, // #EAEEF0

    // Text colors
    colorText: theme.palette.text.primary, // #333333
    colorTextSecondary: theme.palette.text.disabledInput, // #a0a0a0
    colorTextTertiary: theme.palette.text.invalidInput, // #d19191
    colorTextQuaternary: theme.palette.text.validInput, // #475B63

    // Border colors
    colorBorder: theme.palette.background.l1, // #EAEEF0
    colorBorderSecondary: theme.palette.light.l100, // #f0f0f0

    // Border radius
    borderRadius: 4,
    borderRadiusLG: 8,
    borderRadiusSM: 2,

    // Typography
    fontFamily: theme.typography.fontFamily, // "Arial, sans-serif"
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
  },
  // Component-specific configurations
  components: {
    Button: {
      borderRadius: 4,
      primaryColor: theme.palette.text.white, // Primary button text color
    },
    Input: {
      borderRadius: 4,
      colorBgContainer: theme.palette.background.input, // #FFFFFF
    },
    Select: {
      borderRadius: 4,
      controlHeight: 40, 
      paddingContentHorizontal: 12, 
      paddingContentVertical: 8,
      fontSize: 15, 
      optionFontSize: 15, 
      optionPadding: "10px 12px",
    },
    Card: {
      colorBgContainer: theme.palette.background.card, // #FFFFFF
    },
    Modal: {
      colorBgElevated: theme.palette.background.card, // #FFFFFF
      zIndexBase: 1300, // Higher than MUI Drawer (1200) and AppBar (1100)
    },
    Message: {
      colorBgElevated: theme.palette.background.notification, // #EAEEF0
    },
    Notification: {
      colorBgElevated: theme.palette.background.notification, // #EAEEF0
    },
    Collapse: {
      colorBgContainer: theme.palette.background.card, // #FFFFFF
      colorBorder: theme.palette.background.l1, // #EAEEF0
      headerBg: theme.palette.background.card, // #FFFFFF 
      contentBg: theme.palette.background.card, // #FFFFFF
    },
    Tooltip: {
      colorBgSpotlight: theme.palette.background.card, // #FFFFFF - Background color
      colorTextLightSolid: theme.palette.text.primary, // #333333 - Text color
    },
    Menu: {
      colorBgContainer: theme.palette.background.card, // #FFFFFF - Menu background
      colorText: theme.palette.text.primary, // #333333 - Menu text color
      itemBg: theme.palette.background.card, // #FFFFFF - Item background
      itemHoverBg: theme.palette.background.l1, // #EAEEF0 - Item hover background
      itemSelectedBg: theme.palette.primary.main, // #475B63 - Selected item background
      itemSelectedColor: theme.palette.text.white, // #FFFFFF - Selected item text
      itemHoverColor: theme.palette.primary.main, // #475B63 - Hover text color
      itemMarginInline: 8, // Horizontal margin for items
      itemBorderRadius: 6, // Border radius for items
      subMenuItemBorderRadius: 6, // Border radius for submenu items
    },
    Layout: {
      headerBg: theme.palette.background.appbar, // #475B63 - Header background
      bodyBg: theme.palette.background.default, // #EAEEF0 - Body background
      colorBgContainer: theme.palette.background.card, // #FFFFFF - Container background
    },
    Switch: {
      colorPrimary: "#52c41a", // Green when checked (active)
      colorPrimaryHover: "#73d13d", // Lighter green on hover
      handleBg: "#fff", // White handle
      colorTextQuaternary: "#00000040", // Unchecked background (gray with transparency)
      colorTextTertiary: "#00000073", // Unchecked background on hover
    },
  },
};

export default antdTheme;

